var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFermerStores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.566 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 846",
    d: "M63.726 58.32H60.7V5.078A5.084 5.084 0 0 0 55.624 0H10.263a5.084 5.084 0 0 0-5.078 5.078V58.32H1.84a1.84 1.84 0 0 0 0 3.68h61.886a1.84 1.84 0 0 0 0-3.68Zm-6.7-29.2v29.2H34.783V3.673h20.841a1.4 1.4 0 0 1 1.4 1.4v24.044Zm-25.668 3.074V58.32H9.119V5.078a1.4 1.4 0 0 1 1.4-1.4h20.839v28.516Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2472",
    fill: "currentColor",
    d: "M10.387 10.322h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0-50h20v4h-20zm25.405 5h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0 3h20v2h-20zm0-50h20v4h-20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ligne 04",
    d: "M40.292 55.338h-1V8.822h1Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ligne 03",
    d: "M53.292 55.338h-1V8.822h1Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ligne 02",
    d: "M14.887 55.338h-1V8.822h1Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ligne 01",
    d: "M27.887 55.338h-1V8.822h1Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFermerStores);
export default __webpack_public_path__ + "static/media/fermer-stores.8e4a3e228fd2420de2904659ae9913a5.svg";
export { ForwardRef as ReactComponent };